import _ from 'underscore';
import { odata } from '@bingads-webui/http-util';
import { serverContextStore } from '@bingads-webui-campaign/global-context-store';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import { ads } from './test-mock-data/mock';

export default class AdRecommendRepository {
  constructor(options) {
    this.baseURL = `/ODataApi/Campaign/V2${options.baseURL}`;
  }

  getRecommendAds(url) {
    const query = {
      FinalURL: url,
      Locale: _.get(serverContextStore, ['state', 'serverContext', 'CurrentLocale'], 'en-US'),
    };

    const select = [
      'FinalUrls',
      'BusinessName',
      'Headline',
      'LongHeadline',
      'Text',
      'Model.ResponsiveAd/Images',
      'Model.ResponsiveAd/Headlines',
      'Model.ResponsiveAd/LongHeadlines',
      'Model.ResponsiveAd/Descriptions',
    ];

    if (window.e2eTestEnvironment) {
      return Promise.resolve({ value: ads });
    }

    const config = DependencyResolver.get('component/config/index');
    return odata.post(
      `${this.baseURL}Ads/Default.GetResponsiveAdRecommendation?$select=${select.join(',')}`,
      _.extend({ data: query }, { oDataToken: config.get('odata.token') })
    );
  }
}
